import { useApi } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingBlock, ErrorState } from "@/components/common/StateViews";
import { SeverityChip } from "@/components/common/SeverityChip";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { DonutCard } from "@/components/common/Charts";
import { fmtCurrency, timeAgo } from "@/lib/format";
import { ShieldCheck } from "lucide-react";

export default function MyActivity() {
  const { data, isLoading, error } = useApi("activity", "/companion/activity");
  if (error) return <ErrorState />;
  return (
    <div>
      <PageHeader eyebrow="Navitra Companion" title="My Activity" subtitle="Full transparency: what's recorded about your AI use, your savings, and the policy events explained." />
      {isLoading || !data ? <LoadingBlock /> : (
        <div className="space-y-4">
          <Card className="bg-muted/30"><CardContent className="pt-5 flex items-start gap-3"><ShieldCheck className="h-5 w-5 text-sev-success shrink-0 mt-0.5" /><p className="text-sm">{data.data_retained}</p></CardContent></Card>
          <div className="grid lg:grid-cols-3 gap-4">
            <Card className="lg:col-span-2">
              <CardHeader><CardTitle className="font-display text-lg">Recent interactions</CardTitle></CardHeader>
              <CardContent className="p-0">
                <Table>
                  <TableHeader><TableRow><TableHead>Tool</TableHead><TableHead>Use case</TableHead><TableHead>Decision</TableHead><TableHead className="text-right">When</TableHead></TableRow></TableHeader>
                  <TableBody>{data.recent.map((e) => (
                    <TableRow key={e.event_id}><TableCell className="mono text-xs">{e.product}</TableCell><TableCell className="text-sm">{e.use_case}</TableCell><TableCell><SeverityChip level={e.policy.decision} /></TableCell><TableCell className="text-right text-xs text-muted-foreground">{timeAgo(e.ts)}</TableCell></TableRow>
                  ))}</TableBody>
                </Table>
              </CardContent>
            </Card>
            <Card>
              <CardHeader><CardTitle className="font-display text-lg">Spend by tool</CardTitle></CardHeader>
              <CardContent><DonutCard data={data.by_tool} nameKey="tool" valueKey="usd" fmt={(v) => fmtCurrency(v)} /></CardContent>
            </Card>
          </div>
          {data.policy_events.length > 0 && (
            <Card>
              <CardHeader><CardTitle className="font-display text-lg">Policy events, explained</CardTitle></CardHeader>
              <CardContent className="space-y-2">{data.policy_events.map((e) => (
                <div key={e.event_id} className="flex items-center gap-3 rounded-lg border p-3"><SeverityChip level={e.policy.decision} dot /><div className="text-sm"><p>Your {e.use_case.replace(/_/g, " ")} on <span className="mono text-xs">{e.product}</span> was <b>{e.policy.decision}</b>.</p>{e.policy.data_classes.length > 0 && <p className="text-xs text-muted-foreground">Detected: {e.policy.data_classes.join(", ")}</p>}</div></div>
              ))}</CardContent>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}
